'use client';

import { InputAction } from '@eliadmin/core/src/components/nt/forms/controls';
import { useIcoLookup } from '@eliadmin/core/src/components/nt/forms/use-ico-lookup';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { RegisterTextField } from './register-fields';

/**
 * Figma „IČO“ with „Vyhľadať“ and „Údaje o firme doplníme z obchodného registra.“ (221:13989) – the
 * lookup of the checkout's IČO field (`useIcoLookup`).
 */
export function IcoField({ hint }: { hint: string }) {
  const { t } = useTranslations();
  const { available, isLoading, lookup, message } = useIcoLookup();

  return (
    <div className="flex min-w-0 flex-col">
      <RegisterTextField
        name="ico"
        label={t('text42')}
        required
        inputMode="numeric"
        placeholder={t('text42')}
        hint={message || (available ? hint : undefined)}
        action={
          available ? (
            <InputAction onClick={lookup} disabled={isLoading}>
              {isLoading ? <Spinner /> : t('text871')}
            </InputAction>
          ) : null
        }
      />
      <p role="status" className="sr-only">
        {message}
      </p>
    </div>
  );
}
